export const LOGGING_ATTR_PREFIX = 'ws-vehicle-confidence';
export const PROTECTION_PLAN_ROUTE = 'protectionList';

export const ITEMS_ORDER = [
	'returns',
	'warranty',
	'vehicleHistory',
	'protectionPlans',
	'trust'
];
